import React, { useEffect} from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import { connect, useDispatch } from 'react-redux';
import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { getArea, getAreas, postArea, putArea } from '../../store/actions/area/area_action';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';
import TextInput from '../ui_components/text_input';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    typography: {
		margin: theme.spacing(3, 0, 2)
    },
    form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
        '& p': {
            color: '#bf1650',
            '&::before': {
                display: 'inline',
                content: '"⚠ "'
            }
        }
	}
}));

const Area = ({ areas }) => {
    const { uuid } = useParams();
    const { container, typography, form } = useStyles();
    const { control, handleSubmit, reset, formState: { errors } } = useForm();
    const dispatch = useDispatch();

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        uuid && (async () => {
            const area = await getArea(uuid);
            reset(area);
        })();
        !areas.collection.length && dispatch(getAreas());
    }, [uuid]);

    const onSubmit = (data) => {
        if (uuid) {
            enqueueSnackbar(
                'Uspešno sačuvana oblast', {
                variant: 'success'
            });
            return dispatch(putArea(uuid, data));
        }
        enqueueSnackbar(
            'Uspešno dodata oblast', {
            variant: 'success'
        });
        return dispatch(postArea(data));
    }

    const handleClickBackToList = () => {
        history.push(REACT_ROUTES.AREAS);
    }

    return (
        <Container className={container}>
            <Typography align="center" variant="h4" className={typography}>Oblast</Typography>
            <Grid container justify="center" spacing={3}>
                <Grid item>
                    <Button
                        color="primary"
                        size="small"
                        variant="contained"
                        onClick={handleSubmit(onSubmit)}
                        type="button"
                    >
                        Sačuvaj
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleClickBackToList}
                    >
                        Nazad
                    </Button>
                </Grid>
            </Grid>
            <form className={form}>
                <Grid container justify="center" spacing={3}>
                    <Grid item xs={8}>
                        <TextInput
                            control={control}
                            name="name"
                            label="Naziv oblasti"
                            rules={{ required: 'Unesite naziv oblasti' }}
                        />
                        <ErrorMessage errors={errors} name="name" as="p" />
                    </Grid>
                    <Grid item xs={8}>
                        <TextInput
                            name="description"
                            control={control}
                            label="Opis"
                            multiline
                            rows={6}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </form>
        </Container>
    )
}

Area.propTypes = {
    areas: PropTypes.object
}

const mapStateToProps = (state) => ({
    areas: state.areas
});

export default connect(mapStateToProps)(Area);
